export class Country {
  country_name: string;
  country_code: string;

  constructor(country_name: string, country_code: string) {
    this.country_name = country_name;
    this.country_code = country_code;
  }
}
